module.exports = __webpack_public_path__ + "media/images/lb/874-496148ff618c6c373e9ee9c1de5df94b.svg";